import JsonData from "./data.json";

const baseUrl = JsonData.baseUrl;
const logoUrl = `${baseUrl}/static/img/logo.webp`;
const servicesSection = JsonData.Services;

// Общие данные
const commonData = {
  name: servicesSection.name,
  description: servicesSection.text,
  url: `${baseUrl}/metal-restoration-services`,
  logo: logoUrl,
/*   telephone: JsonData.commonData.telephone,
  address: JsonData.commonData.address,
  areaServed: JsonData.commonData.areaServed, */
  telephone: "+7 (921) 654-65-74",
  address: {
    streetAddress: "Салтыковская дорога, 4",
    addressLocality: "Санкт-Петербург",
    postalCode: "195253",
    addressCountry: "RU",
  },
  areaServed: "Санкт-Петербург и Ленинградская область",
};

// Данные для услуг
const services = JsonData.Services.map((service) => ({
  ...service,
  url: `${commonData.url}#${service.slug}`, // Генерация URL на основе слуга
  image: `${baseUrl}/${service.img}`, // Формирование пути к изображению
  price: service.priceSchema
}));

// Основная схема
const metalRestorationSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Lift Blesk",
  description: "Реставрация лифтов и металлических поверхностей: шлифовка, полировка и устранение дефектов.",
  url: commonData.url,
  logo: commonData.logo,
  telephone: commonData.telephone,
  address: {
    "@type": "PostalAddress",
    ...commonData.address,
  },
  areaServed: commonData.areaServed,
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    "name": "Услуги по реставрации лифтов и металлов",
    "itemListElement": services.map((service) => ({
      "@type": "Offer",
      "itemOffered": {
        "@type": "Product",
        "name": service.name,
        "description": service.description,
        "url": service.url,
        "image": service.image,
        "offers": {
          "@type": "Offer",
          "priceCurrency": "RUB",
          "price": service.price,
        },
      },
    })),
  },
};

export default metalRestorationSchema;
